export const ingredients = [
  { label: "zucchini", value: "zucchini" },
  { label: "broccoli", value: "broccoli" },
  { label: "carrots", value: "carrots" },
  { label: "pasta", value: "pasta" },
  { label: "red pepper", value: "red pepper" },
  { label: "onion", value: "onion" },
  { label: "pepperoni", value: "pepperoni" },
  { label: "olive oil", value: "olive oil" },
  { label: "fresh basil", value: "fresh basil" },
  { label: "cheese", value: "cheese" },
  { label: "vegetables", value: "vegetables" },
  { label: "fettuccine", value: "fettuccine" },
  { label: "salt", value: "salt" },
  { label: "chicken", value: "chicken" },
  { label: "beef", value: "beef" },
  { label: "lemon", value: "lemon" },
];

export const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 100, itemsToShow: 2 },
  { width: 200, itemsToShow: 3 },
  { width: 300, itemsToShow: 4 },
];
